import api from './api.service';

export const usuarioService = {
  getAll: async (params?: {
    page?: number;
    limit?: number;
    busqueda?: string;
  }) => {
    const res = await api.get('/usuarios', { params });
    return res.data;
  },

  getById: async (id: number) => {
    const res = await api.get(`/usuarios/${id}`);
    return res.data;
  },

  create: async (data: {
    nombre: string;
    apellido: string;
    email: string;
    password: string;
    rol: string;
    empresaIdDestino?: number;
  }) => {
    const res = await api.post('/usuarios', data);
    return res.data;
  },

  update: async (
    id: number,
    data: Partial<{
      nombre: string;
      apellido: string;
      email: string;
      password: string;
      rol: string;
    }>,
  ) => {
    const res = await api.put(`/usuarios/${id}`, data);
    return res.data;
  },

  delete: async (id: number) => {
    const res = await api.delete(`/usuarios/${id}`);
    return res.data;
  },

  // Obtener preferencias del usuario actual
  getPreferencias: async () => {
    const res = await api.get('/usuarios/preferencias');
    return res.data;
  },

  // Actualizar preferencias del usuario actual
  actualizarPreferencias: async (data: {
    tema?: string;
    idioma?: string;
    zonaHoraria?: string;
    notificacionesEmail?: boolean;
    notificacionesPush?: boolean;
    coloresDark?: {
      primary?: string;
      secondary?: string;
      accent?: string;
      background?: string;
      surface?: string;
      text?: string;
    };
    coloresLight?: {
      primary?: string;
      secondary?: string;
      accent?: string;
      background?: string;
      surface?: string;
      text?: string;
    };
  }) => {
    const res = await api.put('/usuarios/preferencias', data);
    return res.data;
  },

  // Guardar solo los colores del tema
  guardarColores: async (data: {
    coloresDark?: {
      primary?: string;
      secondary?: string;
      accent?: string;
      background?: string;
      surface?: string;
      text?: string;
    };
    coloresLight?: {
      primary?: string;
      secondary?: string;
      accent?: string;
      background?: string;
      surface?: string;
      text?: string;
    };
  }) => {
    const res = await api.put('/usuarios/preferencias', data);
    return res.data;
  },

  getMiPerfil: async () => {
    const res = await api.get('/usuarios/perfil');
    return res.data;
  },
};

export default usuarioService;
